<template>
  <div class="hand">
    <img
      class="hand__book"
      id="hand"
      src="@/assets/images/book_with_hand.png"
      alt="książka"
    />
  </div>
</template>

<script>
export default {
  text: "BookInHand",
  methods: {
    handleSCroll() {
      let book = document.getElementById("hand");
      let bookHeight = book.clientHeight / 2;
      let bookScroll = book.getBoundingClientRect().top + bookHeight;
      if (
        window.scrollY > bookScroll &&
        !book.className.includes("hand__book--animation")
      ) {
        book.classList.add("hand__book--animation");
      }
    },
  },
  created() {
    window.addEventListener("scroll", this.handleSCroll);
  },
  destroyed() {
    window.removeEventListener("scroll", this.handleSCroll);
  },
};
</script>
<style lang="scss">
.hand {
  position: relative;
  overflow: hidden;
  display: block;
  min-height: 27rem;
    @media (min-width: 500px) {
    min-height: 35rem;
  }
   @media (min-width: 600px) {
    min-height: 40rem;
  }
      @media (min-width: 700px) {
    min-height: 46rem;
  }
        @media (min-width: 800px) {
    min-height: 48rem;
  }
    @media (min-width: 900px) {
    min-height: 50rem;
  }
  @media (min-width: 1200px) {
    min-height: 50rem;
  }
  @media (min-width: 1600px) {
    min-height: 66rem;
  }
  position: relative;
  &__book {
    position: absolute;
    left: -750px;
    max-height: 54rem;
    @media (min-width: 1600px) {
      max-height: 65rem;
    }

    &--animation {
      animation: showBook 1s ease-out 1s forwards;
    }
  }
}
@keyframes showBook {
  0% {
    left: -750px;
  }
  100% {
    left: 0%;
  }
}
</style>
